package team.platforma.chat_presentation.di

import org.koin.dsl.module
import team.platforma.chat_presentation.ChatViewModel

val chatPresentationModule = module {
    single {
        ChatViewModel(
            draftUseCase = get(),
            messagesUseCase = get(),
            chatsUseCase = get()
        )
    }
}